import styled from 'styled-components';

import { WorkflowsEmptyState } from 'ui/illustrations';
import { ModalBody } from 'ui/modal';
import { Link } from 'ui/links';
import { colors, H4, Body2, fontWeights } from 'ui/theme';
import { pxToRem } from 'utils/convert';

const StyledBody = styled(ModalBody)`
  background: ${colors.white};
`;

const EmptyContent = styled.div`
  text-align: center;
  padding: ${pxToRem(48)} 0;
  max-width: ${pxToRem(460)};
  margin: auto;

  p {
    color: ${colors.secondaryText};
  }
`;

const SemiBold = styled.span`
  font-weight: ${fontWeights.semiBold};
`;

export const EMPTY_TILESETS = 'empty-tilesets';

export const EmptyTilesets = () => {
  return (
    <StyledBody data-test={EMPTY_TILESETS}>
      <EmptyContent>
        <WorkflowsEmptyState />
        <H4>{"Looks like you don't have any tilesets yet... let's add some!"}</H4>
        <Body2>
          Tilesets let you save and reuse groups of tiles and notes in multiple journeys. To create
          your first tileset, select a group of tiles on the canvas, and click&nbsp;
          <SemiBold>Create tileset</SemiBold>.&nbsp;
          <Link
            hasOpenNewTabIcon
            href={'https://support.iterable.com/hc/en-us/articles/6027159030804'}
            target="_blank"
          >
            Learn More
          </Link>
        </Body2>
      </EmptyContent>
    </StyledBody>
  );
};
